import { lazy } from "react";

// project import
import AuthLayout from "../layout/Auth";
import Loadable from "../components/Loadable";

// render - login
const AuthLogin = Loadable(lazy(() => import("../pages/auth/login")));
const AuthRegister = Loadable(lazy(() => import("../pages/auth/register")));
const AuthForgotPassword = Loadable(
  lazy(() => import("../pages/auth/forgot-password"))
);
const AuthCheckMail = Loadable(lazy(() => import("../pages/auth/check-mail")));
const AuthResetPassword = Loadable(
  lazy(() => import("../pages/auth/reset-password"))
);
const AuthCodeVerification = Loadable(
  lazy(() => import("../pages/auth/code-verification"))
);
const AuthSetPassword = Loadable(
  lazy(() => import("../sections/auth/auth-forms/AuthSetPassword"))
);

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: "/",
  children: [
    {
      path: "/",
      element: <AuthLayout />,
      children: [
        {
          path: "/",
          element: <AuthLogin />,
        },
        {
          path: "login",
          element: <AuthLogin />,
        },
        {
          path: "register",
          element: <AuthRegister />,
        },
        {
          path: "forgot-password",
          element: <AuthForgotPassword />,
        },
        {
          path: "check-mail",
          element: <AuthCheckMail />,
        },
        {
          path: "trocar-senha",
          element: <AuthResetPassword />,
        },
        {
          path: "code-verification",
          element: <AuthCodeVerification />,
        },
        {
          path: "primeiro-acesso",
          element: <AuthSetPassword />,
        },
      ],
    },
  ],
};

export default LoginRoutes;
